import { useLayoutEffect } from 'react';

interface Metadata {
  title?: string;
  description?: string;
}

const usePageMetadata = ({ title, description }: Metadata) => {
  useLayoutEffect(() => {
    const defaultTitle = 'Avantti';
    const defaultOgTitle = 'Avantti';
    const defaultOgDescription = 'Comprá las entradas para tu evento con Avantti';

    let titleChanged = false;
    if (title) {
      const newTitle = `${title} | Avantti`;
      document.title = newTitle;
      document.querySelector('meta[property="og:title"]')?.setAttribute('content', newTitle);
      titleChanged = true;
    }

    let descriptionChanged = false;
    if (description) {
      const metaDescription = document.querySelector('meta[name="description"]');
      const ogDescription = document.querySelector('meta[property="og:description"]');
      metaDescription?.setAttribute('content', description);
      ogDescription?.setAttribute('content', description);
      descriptionChanged = true;
    }

    return () => {
      if (titleChanged) {
        document.title = defaultTitle;
        document.querySelector('meta[property="og:title"]')?.setAttribute('content', defaultOgTitle);
      }
      if (descriptionChanged) {
        document.querySelector('meta[name="description"]')?.setAttribute('content', defaultOgDescription);
        document.querySelector('meta[property="og:description"]')?.setAttribute('content', defaultOgDescription);
      }
    };
  }, [title, description]);
};

export default usePageMetadata;
